import { createContext, useContext } from 'react'

export const ErrorContext = createContext()

export const ErrorProvider = ({ error, children }) => (
  <ErrorContext.Provider value={error}>{children}</ErrorContext.Provider>
)

export const useError = () => useContext(ErrorContext)
